import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'store';

export const notificationsStore = (store: RootState) => store?.notifications;

export const selectUnreadNotificationsCount = createSelector(
  [notificationsStore],
  (store) => store.unreadCount
);
